import { FormikProps } from 'formik';

export interface ICommunicateFormProps extends Partial<FormikProps<CommunicateFormType>> {
  handleClose: () => void;
  loading: boolean;
}

export enum NoteTypeEnum {
  Call = 1,
  Email,
  Text,
  Call_Email,
  Email_Text,
  Call_Email_Text,
  Call_Text,
  Other,
}

export const NoteTypeEnumDescriptions: { [key in NoteTypeEnum]: string } = {
  [NoteTypeEnum.Call]: 'Call',
  [NoteTypeEnum.Email]: 'Email',
  [NoteTypeEnum.Text]: 'Text',
  [NoteTypeEnum.Call_Email]: 'Call/Email',
  [NoteTypeEnum.Email_Text]: 'Email/Text',
  [NoteTypeEnum.Call_Email_Text]: 'Call/Email/Text',
  [NoteTypeEnum.Call_Text]: 'Call/Text',
  [NoteTypeEnum.Other]: 'Other',
};

export const NOTE_TYPE_OPTIONS = [
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Call],
    value: NoteTypeEnum.Call,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Email],
    value: NoteTypeEnum.Email,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Text],
    value: NoteTypeEnum.Text,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Call_Email],
    value: NoteTypeEnum.Call_Email,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Email_Text],
    value: NoteTypeEnum.Email_Text,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Call_Email_Text],
    value: NoteTypeEnum.Call_Email_Text,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Call_Text],
    value: NoteTypeEnum.Call_Text,
  },
  {
    label: NoteTypeEnumDescriptions[NoteTypeEnum.Other],
    value: NoteTypeEnum.Other,
  },
];

export type CommunicateFormType = {
  date: string;
  type: NoteTypeEnum;
  notes: string;
  createdBy?: string;
};
